import { WorkContainer, WorkProject, WorkTask } from '../../_generated/work-rest-api';

export class UserCustomerStateSetContainers {
  static readonly type = '[user-customer] Set containers';

  constructor(public containers: WorkContainer[]) {
  }
}

export class UserCustomerStateSetProjects {
  static readonly type = '[user-customer] Set projects';

  constructor(public projects: WorkProject[]) {
  }
}

export class UserCustomerStateSetSelectedProject {
  static readonly type = '[user-customer] Set selected project';

  constructor(public project: WorkProject) {
  }
}

export class UserCustomerStateSetAppointments {
  static readonly type = '[user-customer] Set appointsments';

  constructor(public appointments: WorkTask[]) {
  }
}

export class UserCustomerStateSetTasks {
  static readonly type = '[user-customer] Set tasks';

  constructor(public tasks: WorkTask[]) {
  }
}
